// extracted by mini-css-extract-plugin
export default {"info":"Counter_info__WSgXU","counter":"Counter_counter__Bq3D7","success":"Counter_success__IBZEg"};